import { useGetUserById, useUpdateUserMutation } from "@/services/users";
import { toast } from "@/components/Toast";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { useEffect } from "react";
import { setUserData } from "@/redux/slices";

const useApis = ({ onNextClick }: { onNextClick?: () => void }) => {
  const dispatch = useDispatch();
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const {
    data: userDetails,
    isLoading: isUserDetailsLoading,
    isRefetching: isUserDetailsRefetching,
  } = useGetUserById({
    id: loggedInUserData?.userId,
    queryParams: {
      enabled: !!loggedInUserData?.userId,
    },
  });

  useEffect(() => {
    if (userDetails?.data) {
      dispatch(setUserData({ ...userDetails?.data }));
    }
  }, [userDetails]);

  // ------------------Update User Info-----------------
  const { mutate: updateUserInfo, isPending: isUpdateUserPending } =
    useUpdateUserMutation({
      onError: (error?: any) => {
        toast.error(
          typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong"
        );
        return error?.response?.data?.message;
      },
      onSuccess: () => {
        toast.success("User Info Updated Successfully");
        onNextClick && onNextClick();
      },
    });

  // -----------------------------------------------------------
  return {
    userDetails,
    updateUserInfo,
    isUpdateUserPending,
    isUserDetailsLoading,
    isUserDetailsRefetching,
  };
};

export default useApis;
